export const AUTH_TYPES = {
  USER_ID: 'USER_ID',
  AUTHORIZATION: 'Authorization',
  ROLE: 'role',
  ROLES: 'roles',
  admin:'admin',

}